angular.module("warsApp").config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('errorResponseInterceptor');
    $httpProvider.interceptors.push('noCacheInterceptor');
    $httpProvider.interceptors.push('configurationInterceptor');
    $httpProvider.interceptors.push('clearGrowlMessagesInterceptor');
    $httpProvider.interceptors.push('breezeInterceptor');
    $httpProvider.interceptors.push('timeZoneInterceptor');
}]);

angular.module("warsApp").config(['growlProvider', '$httpProvider', function (growlProvider, $httpProvider) {
    $httpProvider.interceptors.push(growlProvider.serverMessagesInterceptor);
}]);

angular.module("warsApp").config(['$httpProvider', 'requestTransformerProvider', function ($httpProvider, requestTransformerProvider) {
    var requestTransformer = requestTransformerProvider.$get();
    $httpProvider.defaults.transformRequest.unshift(requestTransformer.scrubDataFromPost);
    $httpProvider.defaults.transformRequest.unshift(requestTransformer.setUndefinedVariablesToNull);
}]);

// Added this so that the AjaxExceptionHandler could differentiate AJAX requests from full page requests
angular.module("warsApp").config(['$httpProvider', function ($httpProvider) {
    $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
}]);